export enum InvoiceDrawerTabs {
  DETAILS,
  COMMENTS,
}

export const tabs = [
  { label: "Details", index: InvoiceDrawerTabs.DETAILS },
  { label: "Comments", index: InvoiceDrawerTabs.COMMENTS },
];
